import { AbstractApiService } from './abstract.api.service';
import { Injectable } from '@angular/core';
import { StorageService } from '../storage.service';
import { ApiManagerService } from './api-manager.api.service';
import { GET_COMPANIES, GET_ACTIVE_COMPANIES } from '../../lib/contsants';

@Injectable({
  providedIn: 'root',
})
export class CompanyApiService extends AbstractApiService {
  constructor(storageService: StorageService, protected apiManager: ApiManagerService) {
    super(storageService);
  }

  protected getApi(endpoint) {
    return this.apiManager.apiBuilder(endpoint);
  }

  async getCompanies() {
    const data = await this.get(this.getApi(GET_COMPANIES));
    return data;
  }

  async getActiveCompanies() {
    const data = await this.get(this.getApi(GET_ACTIVE_COMPANIES));
    return data;
  }

  async getCompany(companyId) {
    const data = await this.get(this.getApi(`${GET_COMPANIES}/${companyId}`));
    return data;
  }

  async saveCompany(company) {
    //setting company baseAPIURL for new companies
    if (!company.id && company.id == null) {
      company.country === 'CH'
        ? (company['baseAPIURL'] = this.apiManager.getApiCH())
        : (company['baseAPIURL'] = this.apiManager.getApiEU());
    }

    const options: RequestInit = {
      body: JSON.stringify(company),
    };
    const data =
      company.id && company.id !== null
        ? await this.patch(
            this.getApi(`${GET_COMPANIES}${company.id ? `/${company.id}` : ``}`),
            options,
          )
        : await this.post(
            this.getApi(`${GET_COMPANIES}${company.id ? `/${company.id}` : ``}`),
            options,
          );
    return data;
  }

  async deleteCompany(companyId) {
    const data = await this.delete(this.getApi(`${GET_COMPANIES}/${companyId}`));
    return data;
  }
}
